import { useParams } from 'react-router-dom';
import api from '../../services/api';
import { useQuery } from "@tanstack/react-query";

export const useGetActiveMotivator = () => {
    const { vendorId } = useParams();
    const fetchData = async () => {
        const { data } = vendorId ? await api.get(`/vendors/${vendorId}/game/`) : { data: null };
        return data;
    };
    return useQuery({
        queryKey: ['ativeGame', vendorId],
        queryFn: fetchData,
        enabled: true,
    });
};